import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from 'services/api';

export const WORKSPACE_TAG = 'Workspace';

export const workspaceApi = createApi({
  reducerPath: 'workspaceApi',
  baseQuery: axiosBaseQuery({
    apiPath: '/api/projects/',
  }),
  endpoints: builder => ({
    // Fetch a project workspace
    getProjectWorkspace: builder.query({
      query: projectId => ({ url: `${projectId}/workspace` }),
      providesTags: [WORKSPACE_TAG],
      transformResponse: response => {
        // when receiving the response, sort by position the steps inside each program_tool
        const toolData = response?.program_tools.map(toolItem => {
          if (toolItem?.steps) {
            toolItem.steps.sort((a, b) => a.position - b.position);
          }
          return toolItem;
        });
        return { ...response, program_tools: toolData };
      },
    }),
  }),
});

export const { useGetProjectWorkspaceQuery } = workspaceApi;
